export const ACCIDENT_INSURANCE_ROUTES = {
  LIST: {
    path: '/accident-insurances',
    name: 'accident-insurances-list',
  },
  ADD: {
    path: '/accident-insurances/add',
    name: 'accident-insurances-add',
  },
  EDIT: {
    path: '/accident-insurances/edit/:id(\\d+)',
    name: 'accident-insurances-edit',
  },
};
